import styles from './Gondola.module.scss';
import qrVault from './assets/qrVault.png';

const Gondola = () => {
    return (
        <section className={styles.wrapper}>
            <div className={styles.details}>
                <div className={styles.headerText}>
                    <h3>Curios?</h3>
                    <p>Scanează codul QR și descoperă o experiență IQOS inedită.</p>
                </div>
                <img src={qrVault} alt="QR Code" className={styles.qrCode} />
            </div>
        </section>
    );
};

export default Gondola;
